__turbopack_context__.v({
  "button": "ToggleButton-module__lRWzMq__button",
  "hiddenInput": "ToggleButton-module__lRWzMq__hiddenInput",
  "size-default": "ToggleButton-module__lRWzMq__size-default",
  "size-large": "ToggleButton-module__lRWzMq__size-large",
  "size-small": "ToggleButton-module__lRWzMq__size-small",
});
